import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {differenceInDays, max, min} from 'ag-common/facades'
import CalendarTooltip from './CalendarTooltip'
import TerminEditDialog from './TerminEditDialog'
import FlyoutAnchor from '../Flyout/FlyoutAnchor'
import {FlyoutPivot} from '../Flyout/FlyoutPivot'
import {FlyoutPosition} from '../Flyout/FlyoutPosition'
import {FlyoutOverflowHandling} from '../Flyout/FlyoutOverflowHandling'
import {connect} from 'react-redux'
import AusbilderTerminEditDialog from '#components/m/Versetzungsplan/AusbilderTerminEditDialog'

const Termin = ({
  id,
  startOfCalendar,
  endOfCalendar,
  isAusbilderTermin = false,
  from,
  to,
  subject,
  gruppenId,
  isDashboardView = false,
  canEditAzubiTermine,
  canEditAusbilderTermin,
  termine,
}) => {
  const [wrapperClassList, setWrapperClassList] = useState(['termin-wrapper'])

  const [showEditDialog, setShowEditDialog] = useState(false)

  const [showDeleteIcon, setShowDeleteIcon] = useState(false)

  useEffect(() => {
    setWrapperClassList(wrapperClassList => [...wrapperClassList, 'fadeIn'])
  }, [])

  const isExpired = differenceInDays(new Date(), to) > 0
  const color = isAusbilderTermin ? 'rgb(64, 66, 69)' : 'rgb(102, 150, 199)'
  const background = isExpired ? 'rgb(153, 153, 153)' : color

  const typeOfTermin = isAusbilderTermin ? 'Ausbilder' : subject

  const gridColumnOffset = isDashboardView ? 0 : 1

  const gridColumn = `${
    differenceInDays(max([from, startOfCalendar]), startOfCalendar) + 1 + gridColumnOffset
  } / span ${differenceInDays(min([to, endOfCalendar]), max([from, startOfCalendar])) + 1}`

  const editableByAzubi = !isDashboardView && !isAusbilderTermin && canEditAzubiTermine
  const editableByAusbilder = !isDashboardView && isAusbilderTermin && canEditAusbilderTermin

  const deactivated = !editableByAzubi && !editableByAusbilder

  const flyoutContent = () => {
    if (editableByAzubi) {
      return (
        <TerminEditDialog
          closed={() => setShowEditDialog(false)}
          subject={subject}
          id={id}
          from={from}
          to={to}
          termine={termine}
        />
      )
    }
    if (editableByAusbilder) {
      return (
        <AusbilderTerminEditDialog
          closed={() => setShowEditDialog(false)}
          subject={subject}
          gruppenId={gruppenId}
          id={id}
        />
      )
    }
    return null
  }

  return (
    <CalendarTooltip text={subject} from={from} to={to} position={CalendarTooltip.Position.TOP}>
      {ref => (
        <div ref={ref} className={wrapperClassList.join(' ')} style={{gridColumn}}>
          <FlyoutAnchor
            flyoutPosition={FlyoutPosition.right}
            flyoutPivot={FlyoutPivot.dynamic}
            openSync={showEditDialog}
            flyoutVisibilityChanged={setShowEditDialog}
            boundingElementClass="termin-edit-bounds"
            deactivated={deactivated}
            overflowHandling={FlyoutOverflowHandling.inversePosition}
            flyoutContent={flyoutContent()}>
            <div className="termin" data-from={from} data-to={to} style={{background}}>
              <div className="termin__termin-info">
                <div className={`termin__termin-info__icon ${typeOfTermin}`} />
                <div className="termin__termin-info__subject">{subject}</div>
                {showDeleteIcon === true && <div>delete?</div>}
              </div>
            </div>
          </FlyoutAnchor>
        </div>
      )}
    </CalendarTooltip>
  )
}

Termin.propTypes = {
  id: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  gruppenId: PropTypes.string,
  from: PropTypes.instanceOf(Date).isRequired,
  to: PropTypes.instanceOf(Date).isRequired,
  isAusbilderTermin: PropTypes.bool,
  startOfCalendar: PropTypes.instanceOf(Date).isRequired,
  endOfCalendar: PropTypes.instanceOf(Date).isRequired,
  termine: PropTypes.arrayOf(PropTypes.object),
  calendarType: PropTypes.string,
  isDashboardView: PropTypes.bool,
  setSelectedTermin: PropTypes.func,
  canEditAzubiTermine: PropTypes.bool.isRequired,
}

function mapStateToProps(state) {
  if (state.authentication.permissions == undefined) {
    return {
      canEditAzubiTermine: false,
      canEditAusbilderTermin: false,
    }
  }
  return {
    canEditAzubiTermine: state.authentication.permissions.versetzungsplan.termine.editAzubiTermin,
    canEditAusbilderTermin: state.authentication.permissions.versetzungsplan.termine.editAusbilderTermin,
  }
}

export default connect(mapStateToProps)(Termin)
